// src/pages/ProtectedPage.js
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";

function ProtectedPage() {
  const { token } = useContext(AuthContext);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) return;

    fetch("http://192.168.100.41:5000/protected", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Unauthorized");
        return res.json();
      })
      .then((data) => setMessage(data.message))
      .catch((err) => setMessage(err.message));
  }, [token]);

  return (
    <div className="container mt-4">
      <h2>Protected Page</h2>
      <p>{message || "Loading..."}</p>
    </div>
  );
}

export default ProtectedPage;

